import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import AlcoCriteria from "./AlcoCriteria";
import { ReportCategory } from "../ReportCategory";
import { Neo } from "@singularsystems/neo-react";

@NeoReport("AlcoReport", { category: ReportCategory.InvestorReports })
export default class AlcoReport extends Report<AlcoCriteria> {

    constructor() {
        super(AlcoCriteria);
    }

    public renderCriteria() {
        return <DateSelectionComponent criteria={this.criteria} />
    }
}